import { Injectable } from '@angular/core';
import { EditService } from 'app/pfm-shared/services/edit.service';

@Injectable()
export class CostCenterAvailableService extends EditService {

  constructor() {
    super('CostCenterProjectAssetMappingView', ['CostCenterId']);
  }
}